export type MediaPlanRow = {
  id?: number;
  name?: string;
  type?: string;
  subRows: Array<MediaPlanRow>;
  subItems?: Array<MediaPlanRow>;
  fields: {
    [metricName: string]: string | number | null;
  };
};

export type UpdateRowRequest = {
  type: string;
  name?: string;
  parent?: number | null;
  channelName?: string;
  mediaPlan?: number | null;
  order?: number;
};

export type UpdateRowResponse = {
  id: number;
  isFromRecommendations?: false;
  name?: string;
  order?: number;
  parent?: number;
  type?: string;
};

export enum ValueType {
  INT = 'int',
  DECIMAL = 'decimal',
  PERCENT = 'percent',
}
